export const handleOperationSuccess = (actionResult, type) => actionResult.status && type === actionResult.type;
